import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { NxMessageToastContext, NxMessageToastService } from '@allianz/ng-aquila/message';
import { SKIP_TOAST } from '@retail-portal-santander-frontend/remote-shared-utils';
import { NGX_LOGGER_CONFIG, NgxLoggerService } from '@allianz/ngx-logger';

export const errorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const toastService = inject(NxMessageToastService);
  const loggerService = inject(NgxLoggerService, { optional: true });
  const loggerConfig = inject(NGX_LOGGER_CONFIG, { optional: true });
  const skipToast = req.context.get(SKIP_TOAST);

  const loggerEndpoint = loggerConfig?.server?.endpoint;
  const isLoggingRequest = !!loggerEndpoint && req.url.includes(loggerEndpoint);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      // prevent infinity loop because logger uses http client
      if (!isLoggingRequest && err?.error?.['traceId']) {
        loggerService?.errorToServer(err?.message, { traceId: err.error['traceId'] });
      }

      if (!skipToast) {
        toastService.open('Something went wrong!', { context: 'error' as NxMessageToastContext });
      }

      return throwError(() => err);
    })
  );
};
